import { load } from "./events/events";

load(()=>{
	const btn = document.createElement("button");
	btn.classList.add("scrollToTop");
	if(window.scrollY>1000){
		btn.classList.add("show");
	}
	btn.addEventListener("click",()=>{
		window.scrollTo({
			top: 0,
			behavior: "smooth"
		});
	})

	document.body.appendChild(btn);
	window.addEventListener("scroll",()=>{
		if(window.scrollY>1000){
			btn.classList.add("show");
			btn.classList.remove("hide");
		}else{
			btn.classList.remove("show");
			btn.classList.add("hide");
		}
	})
})